import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

@Component({
  selector: 'app-device-modal',
  imports: [CommonModule, FormsModule, TableModule, ButtonModule, InputTextModule, DialogModule, IconFieldModule, InputIconModule],
  templateUrl: './device-modal.component.html',
  styleUrl: './device-modal.component.scss'
})
export class DeviceModalComponent {
  @Output() onCancel = new EventEmitter<any>();
  @Input() deviceData!: any[];
  @Input() cardsClient!: any[];
  @Output() deviceDataChange = new EventEmitter<any>();

  dataResult: any[] = [];
  tempData: any[] = [];
  visible = true;
  globalFilter = '';

  get assignedCount() { return this.deviceData.filter(d => d.deviceType === '1' || d.deviceType === '2').length; }
  get totalCount() { return this.deviceData.length; }

  ngOnInit() {
    this.deviceData = this.deviceData.map(device => {
      const card = this.cardsClient.find((c: any) => c.card_id === device.cardId);
      return {
        ...device,
        plates: card?.plates || '',
        nameUser: card?.nameUser || '',
        type: card?.deviceType || null,
        vehicle: card ? card.cardId.toString().padStart(5, '0') : ''
      };
    }).filter((d: any) => d.nameUser.trim() && d.vehicle.trim())
      .sort((a: any, b: any) => b.deviceType.localeCompare(a.deviceType));

    this.tempData = [...this.deviceData];
  }

  select(item: any) {
    const map: any = { '0': '2', '1': '4', '2': '0', '4': '1' };
    item.deviceType = map[item.deviceType] ?? item.deviceType;
    this.updateResult();
  }

  selectAll() {
    const hasUnselected = this.deviceData.some(d => d.deviceType === '0');
    this.deviceData.forEach(d => {
      if (hasUnselected && d.deviceType === '0') d.deviceType = '2';
      else if (hasUnselected && d.deviceType === '4') d.deviceType = '1';
      else if (!hasUnselected && d.deviceType === '2') d.deviceType = '0';
      else if (!hasUnselected && d.deviceType === '1') d.deviceType = '4';
    });
    this.updateResult();
  }

  private updateResult() {
    this.dataResult = this.deviceData.filter(d => d.deviceType === '2' || d.deviceType === '4');
  }

  save() { this.deviceDataChange.emit(this.dataResult); }

  cancel() {
    this.deviceData.forEach(d => {
      if (d.deviceType === '4') d.deviceType = '1';
      else if (d.deviceType === '2') d.deviceType = '0';
    });
    this.dataResult = [];
  }

  close() { this.visible = false; this.onCancel.emit(); }

  searchByText(event: any) {
    const q = event.target.value.toLowerCase();
    this.deviceData = this.tempData.filter(d =>
      d.vehicle.includes(q) || d.nameUser.toLowerCase().includes(q) || (d.plates || '').toLowerCase().includes(q)
    );
  }
}
